/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiRateMatter } from '../models/ApiRateMatter';
import { HttpFile } from '../http/http';

export class ApiBulkRateRequest {
    'matter': ApiRateMatter;
    /**
    * Category of the rating must be set when matter is REP and null if matter is CIC
    */
    'category': string | null;
    'amount_to_add': number;
    'target_wallet_addresses': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "matter",
            "baseName": "matter",
            "type": "ApiRateMatter",
            "format": ""
        },
        {
            "name": "category",
            "baseName": "category",
            "type": "string",
            "format": ""
        },
        {
            "name": "amount_to_add",
            "baseName": "amount_to_add",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "target_wallet_addresses",
            "baseName": "target_wallet_addresses",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiBulkRateRequest.attributeTypeMap;
    }

    public constructor() {
    }
}


